import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";

import UserContext from "store/UserContext";

function AddEditChannelModal(props) {
  console.log("AddEditChannelModal PROPS", props);
  const channel = props.channelInfo;

  const user_context = useContext(UserContext);

  const [isSwitchOn, setIsSwitchOn] = useState(true);
  const [validated, setValidated] = useState(false);
  const [message, setMessage] = useState(<span>&nbsp;</span>);
  const [entityName, setEntityName] = useState();
  const [friendlyUrl, setFriendlyUrl] = useState();
  const [description, setDescription] = useState();
  const [statusCode, setStatusCode] = useState();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchChannelData = async () => {
      if (channel.entity_name) {
        try {
          const channelDataResponse = await axios.get(
            `${apiUrl}channels/${channel.entity_uuid}`,
            myHeaders_Auth_With_Cache_Control
          );

          const { description, friendly_url, entity_name, status_code } =
            channelDataResponse.data;

          setDescription(description);
          setFriendlyUrl(friendly_url);
          setEntityName(entity_name);
          setStatusCode(status_code);
        } catch (e) {
          console.log("FAILED TO FETCH:", e);
        }
      }
    };
    fetchChannelData();
  }, []);

  useEffect(() => {
    if (statusCode === 2) {
      setIsSwitchOn(false);
    }
  }, [statusCode]);
  //handle form typing
  const handleEntityNameTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setEntityName(e.target.value);
  };
  const handleFriendlyUrlTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setFriendlyUrl(e.target.value);
  };
  const handleDescriptionTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setDescription(e.target.value);
  };

  function closeModal() {
    props.handleClose();
    setSaving(false);
    setMessage(<span>&nbsp;</span>);
  }

  //toggle switch function and setting Team Status
  const onSwitchAction = () => {
    if (isSwitchOn) {
      setIsSwitchOn(false);
      setStatusCode(2);
    } else {
      setIsSwitchOn(true);
      setStatusCode(1);
    }
  };
  //UPDATE a team
  async function updateChannelData() {
    if (
      !entityName.trim().length ||
      !friendlyUrl.trim().length ||
      !description.trim().length
    ) {
      setMessage(
        <span style={{ color: "red" }}>Please fill out each field</span>
      );
      setValidated(true);
      return;
    } else {
      let channelData = {
        entity_name: entityName,
        friendly_url: friendlyUrl,
        status_code: statusCode,
        description: description,
      };

      setSaving(true);
      setMessage(<span style={{ color: "green" }}>Saving...</span>);
      if (channel.entity_uuid) {
        //UPDATE THE CHANNEL
        await axios.patch(
          `${apiUrl}channels/${channel.entity_uuid}`,
          channelData
        );
      } else if (!channel.entity_uuid) {
        //ADD A NEW CHANNEL
        await axios.post(`${apiUrl}channels`, channelData);
      }
      closeModal();
    }
  }

  const responsiveTheme =
    user_context.theme === "light"
      ? { backgroundColor: "white", color: "black" }
      : { backgroundColor: "rgb(25,25,25)", color: "white" };

  const formLabel = () => (
    <span>
      <span
        style={{
          fontWeight: !isSwitchOn ? "bold" : "lighter",
        }}
      >
        Inactive
      </span>
      <span> or </span>
      <span
        style={{
          fontWeight: isSwitchOn ? "bold" : "lighter",
        }}
      >
        Active
      </span>
    </span>
  );

  return channel ? (
    <Modal show={props.show} onHide={closeModal}>
      <Modal.Header className="justify-content-around" style={responsiveTheme}>
        <h4>{channel.entity_name ? "Edit Channel" : "Add Channel"}</h4>
        <Form>
          <Form.Switch
            style={{ transform: "scale(1.5)" }}
            onChange={onSwitchAction}
            id="custom-switch"
            label={formLabel()}
            checked={isSwitchOn}
          />
        </Form>
      </Modal.Header>
      <Modal.Body style={responsiveTheme}>
        <Form validated={validated} onSubmit={(e) => e.preventDefault()}>
          <Form.Group controlId="channelName">
            <Form.Label>Channel Name</Form.Label>
            <Form.Control
              type="text"
              onChange={handleEntityNameTyping}
              defaultValue={entityName}
              required
              disabled={saving}
            />
          </Form.Group>

          <Form.Group controlId="friendlyUrl">
            <Form.Label>Friendly Url</Form.Label>
            <Form.Control
              type="text"
              onChange={handleFriendlyUrlTyping}
              defaultValue={friendlyUrl}
              required
              disabled={saving}
            />
          </Form.Group>
          <Form.Group controlId="channelDescription">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              type="text"
              onChange={handleDescriptionTyping}
              defaultValue={description}
              required
              disabled={saving}
            />
          </Form.Group>
        </Form>
        {message}
      </Modal.Body>
      <Modal.Footer style={responsiveTheme}>
        <Button variant="secondary" onClick={() => closeModal()}>
          Close
        </Button>
        <Button variant="pkprimary" onClick={() => updateChannelData()}>
          Save Channel
        </Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <div />
  );
}

export default AddEditChannelModal;
